<div class="mb-32">
  <span class="title title--big">Чек-листы</span>
</div>

<app-tabs [justifyContent]="'center'" [tabActive]="tabActiveManual" (tabChange)="tabChange$.next($event)">
  <app-tab *ngIf="isAdministrator$ | async" [title]="'Формирование чек-листов'" [id]="'composing'"> </app-tab>
  <app-tab *ngIf="isCurratorOrDispatcher$ | async" [title]="'Отчеты'" [id]="'reporting'"></app-tab>
  <app-tab *ngIf="isCurratorOrDispatcherGRRS$ | async" [title]="'Отчёты ГРРС'" [id]="'reporting-grrs'"></app-tab>
</app-tabs>

<router-outlet></router-outlet>
